import { Component } from "@angular/core";

@Component({
  selector: "global-ai-icon-svg",
  standalone: true,
  styles: [
    `
      :host {
        width: 1.1875rem;
        height: 1.06875rem;
      }
    `,
  ],
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <defs>
        <radialGradient id="grad1" cx="50%" cy="50%" r="50%">
          <stop
            offset="0%"
            style="stop-color: rgba(201, 119, 255, 1); stop-opacity: 1"
          />
          <stop
            offset="100%"
            style="stop-color: rgba(255, 72, 157, 1); stop-opacity: 1"
          />
        </radialGradient>
      </defs>

      <path
        fill="url(#grad1)"
        d="M19 8.55126C12.3528 9.49887 10.7332 13.5234 9.5 17.1C8.26331 13.5234 6.64719 9.49887 0 8.55126C6.64719 7.60113 8.26331 3.57658 9.5 0C10.7332 3.57658 12.3528 7.60113 19 8.55126Z"
      />

      <path
        fill="url(#grad1)"
        d="M12.35 2.84825C14.345 2.53407 14.827 1.19191 15.2 0C15.5688 1.19191 16.055 2.53407 18.05 2.84825C16.055 3.16593 15.5688 4.50809 15.2 5.7C14.827 4.50809 14.345 3.16593 12.35 2.84825Z"
      />
    </svg>
  `,
})
export class GlobalAiIconSvgComponent { }
